import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu } from '@headlessui/react';
import {
  UserCircleIcon,
  ShieldCheckIcon,
  UsersIcon,
  ClockIcon,
  BellIcon,
  ArrowRightOnRectangleIcon,
} from '@heroicons/react/24/outline';
import { LuCircleUserRound } from 'react-icons/lu';
import { useUser } from '../context/UserContext';

const NavbarAdmin = ({ toggleDrawer }) => {
  const { user, logout } = useUser();
  const navigate = useNavigate();

  const handleLogout = () => logout();

  const handleGoToAccount = () => {
    if (user?.id) {
      navigate(`/usuarios/${user.id}`);
    }
  };

  return (
    <nav className="bg-white text-gray-800 p-4 sticky top-0 z-50 shadow-sm">
      <div className="flex items-center justify-between max-w-7xl mx-auto">
        {/* Botón hamburguesa para móviles */}
        <button
          onClick={toggleDrawer}
          className="lg:hidden text-gray-600"
          aria-label="Abrir menú"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        {/* Menú de usuario */}
        <Menu as="div" className="relative inline-block text-left ml-auto">
          <Menu.Button className="flex items-center space-x-2 focus:outline-none">
            <LuCircleUserRound className="w-8 h-8 text-gray-700" />
          </Menu.Button>

          <Menu.Items className="absolute right-0 mt-2 w-64 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
            <div className="px-4 py-3 border-b border-gray-200">
              <p className="text-sm font-semibold">
                {user?.first_name} {user?.last_name}
              </p>
              <p className="text-xs text-gray-500 truncate">{user?.email}</p>
            </div>

            <div className="py-1">
              <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={handleGoToAccount}
                    className={`${active ? 'bg-gray-100' : ''} w-full px-4 py-2 text-sm text-left flex items-center gap-2`}
                  >
                    <UserCircleIcon className="w-5 h-5 text-gray-500" />
                    Información de la cuenta
                  </button>
                )}
              </Menu.Item>
              <Menu.Item>
                {({ active }) => (
                  <button className={`${active ? 'bg-gray-100' : ''} w-full px-4 py-2 text-sm text-left flex items-center gap-2`}>
                    <ShieldCheckIcon className="w-5 h-5 text-gray-500" />
                    Seguridad
                  </button>
                )}
              </Menu.Item>
              <Menu.Item>
                {({ active }) => (
                  <button className={`${active ? 'bg-gray-100' : ''} w-full px-4 py-2 text-sm text-left flex items-center gap-2`}>
                    <UsersIcon className="w-5 h-5 text-gray-500" />
                    Uso compartido de cuenta
                  </button>
                )}
              </Menu.Item>
              <Menu.Item>
                {({ active }) => (
                  <button className={`${active ? 'bg-gray-100' : ''} w-full px-4 py-2 text-sm text-left flex items-center gap-2`}>
                    <ClockIcon className="w-5 h-5 text-gray-500" />
                    Actividad de la cuenta
                  </button>
                )}
              </Menu.Item>
              <Menu.Item>
                {({ active }) => (
                  <button className={`${active ? 'bg-gray-100' : ''} w-full px-4 py-2 text-sm text-left flex items-center gap-2`}>
                    <BellIcon className="w-5 h-5 text-gray-500" />
                    Ajustes de notificaciones
                  </button>
                )}
              </Menu.Item>
            </div>

            <div className="border-t border-gray-200">
              <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={handleLogout}
                    className={`${active ? 'bg-gray-100' : ''} w-full px-4 py-2 text-sm text-left flex items-center gap-2 text-red-600`}
                  >
                    <ArrowRightOnRectangleIcon className="w-5 h-5 text-red-500" />
                    Salir
                  </button>
                )}
              </Menu.Item>
            </div>
          </Menu.Items>
        </Menu>
      </div>
    </nav>
  );
};

export default NavbarAdmin;
